import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LiveAccountModal } from '@/components/portal/LiveAccountModal'

export function LiveAccountPage() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/dashboard?live=1', { replace: true })
  }, [navigate])

  return <LiveAccountModal open onClose={() => navigate('/dashboard')} />
}
